export const UNSUPPORTED_VIDEO_EXT = ['.avi', '.mkv', '.flv', '.wmv', '.3gp', '.divx', '.xvid']
export const UNSUPPORTED_VIDEO_MIME = [
  'video/x-msvideo',
  'video/x-matroska',
  'video/x-flv',
  'video/x-ms-wmv',
  'video/3gpp',
]

/**
 * Checks if a given file has an unsupported video format/extension.
 */
export function isUnsupportedVideoFile(file: File | { name: string; type?: string }): boolean {
  const ext = file.name.toLowerCase().match(/\.[^.]+$/)?.[0] ?? ''
  const mime = (file.type || '').toLowerCase()
  return UNSUPPORTED_VIDEO_EXT.includes(ext) || UNSUPPORTED_VIDEO_MIME.includes(mime)
}

/**
 * Validates an array of media files for supported video formats.
 * Returns { valid: true } or { valid: false, error: string }.
 */
export function validateMediaFiles(files: File[]): { valid: boolean; error?: string } {
  for (const file of files) {
    if (isUnsupportedVideoFile(file)) {
      return {
        valid: false,
        error: `Video "${file.name}" format is not supported. Please convert your video to MP4, MOV, WebM, or M4V format before uploading. You can use free tools like HandBrake or VLC to convert your video.`,
      }
    }
  }
  return { valid: true }
}

/**
 * Computes a SHA-256 hash of the first 10MB of a file using Web Crypto API.
 * Matches backend hash calculation for instant duplicate detection before upload.
 */
export async function computeFileContentHash(fileBlob: Blob): Promise<string> {
  const maxBytes = 10 * 1024 * 1024
  const slice = fileBlob.size > maxBytes ? fileBlob.slice(0, maxBytes) : fileBlob
  const arrayBuffer = await slice.arrayBuffer()
  const hashBuffer = await crypto.subtle.digest('SHA-256', arrayBuffer)
  const hashArray = Array.from(new Uint8Array(hashBuffer))
  return hashArray.map((b) => b.toString(16).padStart(2, '0')).join('')
}

